import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
    Card, CardBody, Row, Button
} from '@Comp';
import images from '@assets';
import { View } from '../../../shared/components';
import '../style.scss';

const EmailConfirmedPage = (props) => {
    const { history, location } = props;
    const [email, setEmail] = useState('');
    const [countdown, setCountdown] = useState(5);

    useEffect(() => {
        // Parse email from query parameters
        const queryParams = new URLSearchParams(location.search);
        const emailParam = queryParams.get('email');
        if (emailParam) {
            setEmail(decodeURIComponent(emailParam));
        }

        // Countdown timer
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    history.push('/login');
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [location.search, history]);

    const handleLoginNow = () => {
        history.push('/login');
    };

    return (
        <View>
            <div className="view-content view-content-login view-pages view-session d-flex justify-content-center align-items-center flex-column">
                <Row>
                    <div className="col-md-7 mb-7 d-none d-md-block">
                        <img className="img-fluid" src={images.loginIcon} alt="" />
                        <div className="m-t-15 m-l-20">
                            <h1 className="font-weight-light font-size-35 text-white">Email Confirmed!</h1>
                            <p className="text-white width-70 text-opacity m-t-25 font-size-16">
                                Your email address has been successfully verified. You can now access all features of your account.
                            </p>
                            <div className="m-t-60">
                                <a href="#" className="text-white text-link m-r-15">Term &amp; Conditions</a>
                                <a href="#" className="text-white text-link">Privacy &amp; Policy</a>
                            </div>
                        </div>
                    </div>

                    <Card className="col-md-5 mb-5 form-card">
                        <CardBody>
                            <header className="mb-5 text-center">
                                <div className="mb-4">
                                    <svg
                                        width="80"
                                        height="80"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="#28a745"
                                        strokeWidth="2"
                                        className="mx-auto"
                                    >
                                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                    </svg>
                                </div>
                                <h2 className="text-success">Email Confirmed!</h2>
                                <p className="sublead mt-3">
                                    {email && (
                                        <>
                                            Your email <strong>{email}</strong> has been successfully verified.
                                        </>
                                    )}
                                    {!email && 'Your email has been successfully verified.'}
                                </p>
                            </header>

                            <div className="text-center mb-4">
                                <p className="text-muted">
                                    You can now log in to your account and start using all the features.
                                </p>
                            </div>

                            <div className="text-center mb-3">
                                <Button
                                    color="info"
                                    size="lg"
                                    block
                                    onClick={handleLoginNow}
                                >
                                    Login Now
                                </Button>
                            </div>

                            <div className="text-center">
                                <p className="text-muted small">
                                    Redirecting to login in {countdown} second{countdown !== 1 ? 's' : ''}...
                                </p>
                            </div>
                        </CardBody>
                    </Card>
                </Row>
            </div>
        </View>
    );
};

const EmailConfirmed = withRouter(EmailConfirmedPage);
export default EmailConfirmed;
